import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';
import Code from 'components/Code';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoClassificationCertificate extends Component {

    render() {
        const { classificationCertificate } = this.props;
        const summary = getTitleSummary(classificationCertificate)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Классификационные решения'],
                    rows: summary
                }}
                expanded={(classificationCertificate.length !== 0) ? true : false}
                table={{
                    headers: [
                        '',
                        'Код',
                        'Описание',
                        'Нормативный документ'
                    ],
                    rows: classificationCertificate.map(({ to_date = null, code = '', description = '', order, order_date, orders_info = null }) => ([
                        <ToDateNotificator to_date={to_date} />,
                        <Code code={code} />,
                        description,
                        formatOrder(order, order_date, orders_info)
                    ]))
                }}
            />
        );
    }
}

function getTitleSummary(items) {
    return items.length !== 0 ? [['есть']] : null;
}






// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoClassificationCertificate.js